import React, { useState, useEffect } from 'react';
import {
  Button,
  FormControl,
  FormControlLabel,
  //   FormLabel,
  Grid,
  // InputLabel,
  MenuItem,
  //   InputLabel,
  //   MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { FiBankList } from 'API/Reports';

const SearchFilter = (props) => {
  const State = props.State;
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z0-9\s]/g, '');
  };
  const [BankList, setBankList] = useState('');

  useEffect(() => {
    FiBankList(setBankList);
  }, []);
  return (
    <>
      <Grid container spacing={2} alignItems="center" wrap="wrap">
        {/* Search Field */}
        <Grid item>
          {props?.filter?.user_type === 'bank_name' ? (
            <FormControl fullWidth>
              {/* <InputLabel id="demo-simple-select-label">Bank name</InputLabel> */}
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                Bank name
              </Typography>
              <Select
                // label="Bank name"
                size="small"
                name="search"
                value={props.filter?.search || 'select'}
                onChange={props.handleChange}
                sx={{ minWidth: 200 }}
              >
                <MenuItem value={'select'} disabled>
                  Select
                </MenuItem>
                {BankList &&
                  BankList.map((bank, index) => (
                    <MenuItem value={bank.Bankname} key={index}>
                      {bank.Bankname.toUpperCase()}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          ) : (
            <>
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                Search
              </Typography>
              <TextField
                id="outlined-basic"
                name="search"
                value={props.filter?.search || ''}
                onInput={handleInput}
                label="Search"
                variant="outlined"
                size="small"
                onChange={props.handleChange}
                disabled={!props.filter?.user_type}
                sx={{ minWidth: 200 }}
              />
            </>
          )}
        </Grid>
        {/* User Type Radio Group */}
        <Grid item>
          <FormControl size="small">
            {/* <FormLabel>User Type</FormLabel> */}
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              Search By
            </Typography>
            <RadioGroup row name="user_type" value={props.filter?.user_type || ''} onChange={props.handleChange}>
              {/* <FormControlLabel value="Application ID" control={<Radio size="small" />} label="Application ID" /> */}
              <FormControlLabel value="csp_code" control={<Radio size="small" />} label="CSP Code" />
              <FormControlLabel value="agent_name" control={<Radio size="small" />} label="CSP Name" />
              <FormControlLabel value="agent_code" control={<Radio size="small" />} label="Agent code" />
              <FormControlLabel value="bank_name" control={<Radio size="small" />} label="Bank name" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl fullWidth>
            {/* <InputLabel id="demo-simple-select-label">State</InputLabel> */}
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              State
            </Typography>
            <Select
              // label="State"
              name="retail_state"
              size="small"
              value={props?.filter?.retail_state ? props?.filter?.retail_state : 'select'}
              onChange={props?.handleChange}
              sx={{ minWidth: 120 }}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {State &&
                Object.entries(State).map(([key]) => (
                  <MenuItem value={key} key={key}>
                    {key}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl fullWidth>
            {/* <InputLabel id="demo-simple-select-label">District</InputLabel> */}
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              District
            </Typography>
            <Select
              // label="District"
              name="retail_district"
              size="small"
              value={props?.filter?.retail_district ? props?.filter?.retail_district : 'select'}
              disabled={!props?.filter?.retail_state}
              onChange={props.handleChange}
              sx={{ minWidth: 120 }}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {props?.filter?.retail_state &&
                State &&
                State[props?.filter?.retail_state] &&
                State[props?.filter?.retail_state].map((item, index) => (
                  <MenuItem value={item} key={index}>
                    {item}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        {/* Clear Button */}
        <Grid item mt={3}>
          <Button
            variant="outlined"
            color="secondary"
            sx={{
              backgroundColor: '#592375',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#592375'
              }
            }}
            size="small"
            onClick={props.handleClear}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default SearchFilter;
